//components
import Button from '../../CustomButton/CustomButton.jsx';

//utils
import { shortDateFormat, timeFormat } from '../../../utils/dateFormat';
import { statusMap } from '../../../utils/normalStatuses';

function AbsenceAdjustmentByTimesheet({ userPromptModal, t, dateTimeRules }) {
    const absenceAdjustmentByTimesheetData = userPromptModal.sourceInfo.absenceAdjustmentByTimesheet;
    return (
        <div>
            <div className='fw-bold text-danger'>{absenceAdjustmentByTimesheetData.timesheetIntersection.error}</div>
            <div className="row timelog-grid-time-card">
                <table className='table mt-0'>
                    <thead>
                        <tr>
                            <th>{t('Date')}</th>
                            <th>{t('Start Time')}</th>
                            <th>{t('End Time')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{absenceAdjustmentByTimesheetData.timesheetIntersection.timesheets[0].from_date}</td>
                            <td>{timeFormat(absenceAdjustmentByTimesheetData.timesheetIntersection.timesheets[0].start_time, dateTimeRules)}</td>
                            <td>{timeFormat(absenceAdjustmentByTimesheetData.timesheetIntersection.timesheets[0].end_time, dateTimeRules)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {absenceAdjustmentByTimesheetData.absenceAdjustments?.canAbsenceTimeAdjusted ?
                <div>
                    <div className='fw-bold'>{t('If you want to adjust the absence time as following then please click adjust button and save absence.')}</div>
                    <div className="row timelog-grid-time-card">
                        <table className='table mt-0'>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{t('Start Time')}</th>
                                    <th>{t('End Time')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ width: '40%' }}>{`${t('Absence')}`}</td>
                                    <td>{timeFormat(absenceAdjustmentByTimesheetData.absenceAdjustments.start_time, dateTimeRules)}</td>
                                    <td>{timeFormat(absenceAdjustmentByTimesheetData.absenceAdjustments.end_time, dateTimeRules)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <Button fill wd onClick={() => userPromptModal.actionMethods.adjustAbsenceForTimesheet({
                        start_time: absenceAdjustmentByTimesheetData.absenceAdjustments.start_time,
                        end_time: absenceAdjustmentByTimesheetData.absenceAdjustments.end_time
                    })}>
                        <i class="fas fa-sliders-h margin-right-10"></i>
                        {t('Adjust Absence')}
                    </Button>
                </div> : null}
        </div>
    )
}

function CancelAbsenceVacation({ userPromptModal, t, dateTimeRules }) {
    const cancelAbsenceVacationData = userPromptModal.sourceInfo.cancelAbsenceVacation;
    const showProceedAsMandatory = userPromptModal.actions && userPromptModal.actions.some(ele => ele.action === 'PROCEED_WITH_MANDATORY_TIMESHEET');
    return (
        <div>
            <div>{t(cancelAbsenceVacationData.errorMessage)}</div>

            <div className={`d-flex justify-content-end mt-3 mb-1 gap-2 ${showProceedAsMandatory ? 'flex-column' : ''}`}>
                <Button fill wd onClick={userPromptModal.actionMethods.handleAbsenceVacationCancelAndProceed}>
                    {t('Cancel And Proceed')}
                </Button>
                <Button onClick={userPromptModal.actionMethods.handleAbsenceVacationCheckAndCancelManually}>
                    {t('Check And Cancel Manually')}
                </Button>
                {
                    showProceedAsMandatory &&
                    <Button fill success wd onClick={userPromptModal.actionMethods.handleAbsenceWithMandatoryOvertimeFlexitime}>
                        {t('Proceed as Mandatory Overtime/Flexitime')}
                    </Button>
                }
            </div>
        </div>
    )
}

function MedicalLeaveMassStatus({ userPromptModal, t, dateTimeRules }) {
    const { handleCloseUserPromptModal, handleMedicalLeaveMassStatus } = userPromptModal.actionMethods;
    const { message, action, absences } = userPromptModal.sourceInfo.medicalLeaveMassStatus;
    const massAction = userPromptModal.actions && userPromptModal.actions.find(ele => ele.action === 'APPROVE_ALL_MEDICAL_LEAVES' || ele.action === 'RESET_ALL_MEDICAL_LEAVES');
    return (
        <div>
            <p className={`fw-bold ${action === 'reset_all' ? 'text-danger' : ''}`}>{t(message)}</p>
            {absences && absences.length > 0 && (
                <div className="row timelog-grid-time-card">
                    <table className='table mt-0'>
                        <thead>
                            <tr>
                                <th>{t('Date')}</th>
                                <th>{t('Time')}</th>
                                <th>{t('Total days')}</th>
                                <th>{t('Status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {absences.map((a, index) => (
                                <tr key={a.id || index}>
                                    <td>{shortDateFormat(a.from, dateTimeRules)} | {shortDateFormat(a.to, dateTimeRules)}</td>
                                    <td>
                                        {a.start_time !== null && a.end_time !== null
                                            ? `${timeFormat(a.start_time, dateTimeRules)} - ${timeFormat(a.end_time, dateTimeRules)}`
                                            : '-'}
                                    </td>
                                    <td>{a.employement_grade < 100 ? `${a.total_days} d (${a.hours} h)` : `${a.total_days} d`}</td>
                                    <td>{t(statusMap[a.status] || a.status)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <div className="d-flex justify-content-end mb-1">
                {massAction && handleMedicalLeaveMassStatus && (
                    <Button fill wd success={action === 'approve_all'} warning={action === 'reset_all'} onClick={handleMedicalLeaveMassStatus}>
                        {t(action === 'reset_all' ? 'Reset' : 'Approve')} {t('All')}
                    </Button>
                )}
                <Button wd onClick={handleCloseUserPromptModal} className="ms-3">
                    {t('Close')}
                </Button>
            </div>
        </div>
    )
}

export {
    AbsenceAdjustmentByTimesheet,
    CancelAbsenceVacation,
    MedicalLeaveMassStatus
};